"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * Axios interceptor to retry ECONNRESET errors once.
 *
 * @see https://github.com/node-modules/agentkeepalive/blob/01e61e9/README.md#support-reqreusedsocket
 */
var _default = function _default() {
  return {
    success: function success(res) {
      return res;
    },
    error: function () {
      var _error2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_error) {
        var config, request, code, _ref, reusedSocket;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = _error.config, request = _error.request, code = _error.code;
                _ref = request || {}, reusedSocket = _ref.reusedSocket;

                if (!(reusedSocket && code === 'ECONNRESET' && !config._econnresetRetry)) {
                  _context.next = 5;
                  break;
                }

                config._econnresetRetry = true;
                return _context.abrupt("return", (0, _axios["default"])(config));

              case 5:
                return _context.abrupt("return", Promise.reject(_error));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function error(_x) {
        return _error2.apply(this, arguments);
      }

      return error;
    }()
  };
};

exports["default"] = _default;